import React from 'react';
import { Section } from './ui/Section';
export function ForWho() {
  const points = [{
    title: 'Eres buen bailarín pero te sientes perdido al explicar técnica',
    desc: 'Sabes moverte, pero te falta la metodología para transmitirlo con claridad.'
  }, {
    title: 'Llegas a la academia y decides la figura 5 minutos antes',
    desc: 'Estás cansado de la ansiedad que genera no tener una estructura profesional.'
  }, {
    title: 'Tus alumnos se estancan y no ven progresión',
    desc: 'Sientes que siempre das lo mismo y te da miedo que se aburran y se vayan a otra escuela.'
  }, {
    title: 'Quieres que tu pasión sea un negocio serio',
    desc: 'Necesitas dejar de ser "el que da clases" para ser el Instructor de Referencia de tu ciudad.'
  }];
  return <Section data-id="element-137">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-138">
        💡 ESTE MANUAL ES PARA TI SI...
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-139">
        {points.map((point, i) => <div key={i} className="bg-gradient-card border border-brand-border rounded-xl p-6 shadow-card hover:shadow-violet-glow transition-all hover:border-brand-borderGlow/40 flex items-start gap-4" data-id="element-140">
            <span className="text-green-400 text-2xl shrink-0" data-id="element-141">✅</span>
            <div data-id="element-142">
              <h3 className="font-heading font-bold text-brand-subtitle mb-2 tracking-wide" data-id="element-143">
                {point.title}
              </h3>
              <p className="font-body text-brand-text text-sm" data-id="element-144">{point.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}